import DateTimeHelper from "./DateTimeHelper";
import {logDebug} from "./AppLog";
import auth from "src/js/utils/auth";
import {locString} from "src/js/components/commons/ViewHelper";

export const LOCATION_UNAVAILABLE = 1;
export const LOCATION_DENIED = 2;
export const LOCATION_TIMEOUT = 3;

export default class LocationHelper {

  static location = auth.getPickedLocation();

  static isLocationPresent() {
    return "geolocation" in navigator;
  }

  static getPastLocation() {
    return this.location;
  }

  static getLocation(onSuccess, onError) {
    const handleError = (errorCode, errorMessage) => {
      let savedLocation = auth.getManualPickedLocation();
      if (savedLocation) {
        let expiryTimeMS = 10 * 60 * 1000;
        if (savedLocation.inMap) {
          expiryTimeMS = 48 * 60 * 60 * 1000; // 2 days
        }
        if (Date.now() - savedLocation.time > expiryTimeMS) {
          savedLocation = null;
        }
      }
      locString('savedLocation', savedLocation);
      if (savedLocation) {
        onSuccess(savedLocation);
      } else if (onError) {
        onError(errorCode, errorMessage);
      }
    }
    const startTime = new Date();
    if (!this.location || Date.now() - this.location.time > 10 * 60 * 1000) {
      if (this.isLocationPresent()) {
        navigator.geolocation.getCurrentPosition((successCallback) => {
          logDebug("DG:GeolocationSuccess", successCallback);
          const locationAt = Date.now();
          this.location = successCallback.coords;
          this.location.time = locationAt;

          auth.setPickedLocation({
            latitude: this.location.latitude,
            longitude: this.location.longitude,
            altitude: this.location.altitude,
            accuracy: this.location.accuracy,
            time: locationAt,
          });
          onSuccess(this.location);

        }, (positionError) => {
          logDebug("DG:GeolocationError", positionError);
          const delayInSecs = Math.max(0, 0.5 - DateTimeHelper.getSecondsDiffFromNow(startTime));
          setTimeout(() => {
            if (onError) {
              let errorCode = LOCATION_TIMEOUT;
              try {
                if (positionError.code === GeolocationPositionError.PERMISSION_DENIED) {
                  errorCode = LOCATION_DENIED;
                } else if (positionError.code === GeolocationPositionError.POSITION_UNAVAILABLE) {
                  errorCode = LOCATION_UNAVAILABLE;
                }
              } catch (ex) {
                errorCode = LOCATION_UNAVAILABLE;
              }
              handleError(errorCode, positionError.message);
            }
          }, delayInSecs * 1000);
        }, {enableHighAccuracy: true, maximumAge: 10 * 60 * 1000, timeout: 10 * 1000});
      } else {
        handleError(LOCATION_UNAVAILABLE, 'Location is not available');
      }
    } else {
      onSuccess(this.location);
    }
  }

}
